import "@/scss/styles.scss";
import { getGlobal } from "@/functions/getGlobal";
import { Suspense, useMemo } from "react";
import { getMetaLanguageAlternates } from "@/functions/getLanguageAlternates";
import { SiteFooter, SiteHeader, ReciteMeWidget } from "@/ui";
import { useRouter } from "next/router";
import SourceFlowHead from "@sourceflow-uk/sourceflow-head";
import metaObject from "../../.sourceflow/metadata.json";

export default function App({ Component, pageProps }) {
  const global = getGlobal();

  const router = useRouter();
  const languageAlternates = useMemo(() => getMetaLanguageAlternates(metaObject, router.asPath), [router.asPath]);

  // Exclude `/components` page from being wrapped in Layout and SourceFlowHead
  const isComponentsPage = router.pathname === "/components";
  return isComponentsPage ? (
    <Suspense>
      <SiteHeader className={global["_theme.header.classes"]} />
      <main className="flex-grow-1">
        <Component {...pageProps} />
      </main>
      <SiteFooter className={global["_theme.footer.classes"]} />
    </Suspense>
  ) : (
    <Suspense>
      <SourceFlowHead
        metaObject={metaObject}
        addTracker={true}
        cookieExpiryTime={3000}
        title={pageProps?.meta?.title ?? null}
        languageAlternates={languageAlternates}
      />
      <SiteHeader className={global["_theme.header.classes"]} />
      <main className="flex-grow-1">
        <Component {...pageProps} />
      </main>
      <SiteFooter className={global["_theme.footer.classes"]} />
    </Suspense>
  );
}
